(function(){
  if(window.__gjFixes)return;window.__gjFixes=1;
  var css='.slideshow__button{display:flex;flex-direction:column;gap:1.2rem;align-items:stretch}'
    +'.gj-customize-now{background:#0b45ff!important;border-color:#0b45ff!important;color:#fff!important;text-align:center}'
    +'.gj-customize-now:hover{background:#0938d6!important;border-color:#0938d6!important}'
    +'.gj-shop-now{background:#fff!important;border-color:#fff!important;color:#1a1b18!important;text-align:center}'
    +'.gj-roster-btn-wrap{text-align:center;margin-top:2.4rem}'
    +'@media screen and (min-width:750px){.slideshow--only1 .slideshow__image{padding-bottom:min(52.76%,calc(100vh - 200px))!important;height:auto!important;min-height:0!important;max-height:none!important}.slideshow--only1 .slideshow__image img{object-fit:cover!important;object-position:center!important}.slideshow__button{position:absolute!important;right:56px!important;bottom:56px!important;left:auto!important;top:auto!important;width:auto!important;margin:0!important;z-index:5;flex-direction:column!important;align-items:stretch!important}.slideshow--legacy .slideshow__content{padding-bottom:64px!important}.collage--left,.collage--right{grid-auto-flow:row!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;align-items:start!important}.collage--left>.collage__item,.collage--right>.collage__item{grid-column:auto!important;grid-row:auto!important}.collage--left .collage-card .media,.collage--right .collage-card .media{aspect-ratio:3/4!important;padding-bottom:0!important;height:auto!important}}'
    +'@media(max-width:749px){.slideshow__heading{font-size:2.5rem!important;line-height:1.05!important;text-align:center!important;width:100%!important;margin-bottom:.4rem!important}.slideshow .full-unstyled-link{z-index:1!important;pointer-events:none!important}.slideshow__card{transform:translateY(22px);position:relative;z-index:6}.slideshow__button{flex-direction:row!important;flex-wrap:nowrap;gap:.7rem;width:100%!important;max-width:100%;justify-content:center!important;margin-top:.4rem!important;position:relative!important;z-index:7!important}.slideshow__button .button{font-size:1.15rem!important;padding:.85rem 1.2rem!important;min-height:0!important;white-space:nowrap;position:relative;z-index:7}.gj-roster-btn-wrap{margin-top:1.6rem}.gj-roster-btn{font-size:1.3rem!important;padding:.9rem 1.8rem!important;min-height:0!important}}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);
  function ensureBtns(w){
    if(!w.querySelector('.gj-customize-now')){
      var a=document.createElement('a');
      a.className='button gj-customize-now';
      a.href='/products/custom-jersey';
      a.textContent='CUSTOMIZE NOW';
      w.insertBefore(a,w.firstChild);
    }
    if(w.querySelectorAll('.button:not(.gj-customize-now)').length===0){
      var s=document.createElement('a');
      s.className='button gj-shop-now';
      s.href='/collections/players';
      s.textContent='SHOP NOW';
      w.appendChild(s);
    }
  }
  function addBtn(){
    var cards=document.querySelectorAll('.slideshow__card');
    if(cards.length){
      cards.forEach(function(c){
        var w=c.querySelector('.slideshow__button');
        if(!w){w=document.createElement('div');w.className='slideshow__button';c.appendChild(w);}
        ensureBtns(w);
      });
      return true;
    }
    var ws=document.querySelectorAll('.slideshow__button');
    if(!ws.length)return false;
    ws.forEach(ensureBtns);
    return true;
  }
  function addRoster(){
    if(document.querySelector('.gj-roster-btn'))return true;
    var sec=null,g=document.querySelector('.gallery');
    if(g)sec=g.closest('[id^="shopify-section"]')||g.closest('.section');
    if(!sec){
      var hs=document.querySelectorAll('h1,h2,h3,.title');
      for(var i=0;i<hs.length;i++){if(/roster/i.test(hs[i].textContent||'')){sec=hs[i].closest('[id^="shopify-section"]')||hs[i].closest('.section');break;}}
    }
    if(!sec)return false;
    var wrap=document.createElement('div');
    wrap.className='gj-roster-btn-wrap';
    var a=document.createElement('a');
    a.className='button gj-roster-btn';
    a.href='/pages/athletes';
    a.textContent='SEE ALL ATHLETES';
    wrap.appendChild(a);
    (sec.querySelector('.page-width')||sec).appendChild(wrap);
    return true;
  }
  function killOverlay(){
    var m=window.matchMedia('(max-width:749px)').matches;
    var ls=document.querySelectorAll('.slideshow .full-unstyled-link');
    for(var i=0;i<ls.length;i++){ls[i].style.pointerEvents=m?'none':'';}
  }
  window.addEventListener('resize',killOverlay);
  function run(){var a=addBtn();var b=addRoster();killOverlay();return a&&b;}
  if(!run()){
    document.addEventListener('DOMContentLoaded',run);
    var n=0,t=setInterval(function(){if(run()||++n>40)clearInterval(t)},250);
  }
  document.addEventListener('shopify:section:load',run);
  if(window.Shopify&&window.Shopify.designMode)setInterval(run,1500);
})();
